import { LoaderService } from './../loder_service/loader.service';
import { DataService } from './../data.service';
import { Storage } from '@ionic/storage';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-wallet',
  templateUrl: './wallet.component.html',
  styleUrls: ['./wallet.component.scss'],
})
export class WalletComponent implements OnInit {
  cart_count:any=0;
  walletBalance:any;
  get_wallet_transaction:any;
  constructor(public restApi:DataService,public toastService:LoaderService,public router:Router, public storage:Storage) { 
    
      if(localStorage.getItem('cart_count')){
        this.cart_count=localStorage.getItem('cart_count');
      
      }else{
        this.cart_count=0;
      }
  
 
  }

  ngOnInit() {}
ionViewWillEnter(){
  this.toastService.showLoader('')

 if(localStorage.getItem('user_id')){
   console.log(localStorage.getItem('user_id'))
   let postparams={
    userLoginid:localStorage.getItem('user_id')
   }
   this.restApi.get_wallet_details(postparams).subscribe((data:any)=>{
      this.walletBalance=data.walletBalance
      this.get_wallet_transaction=data.get_wallet_transaction;
      //alert(this.walletBalance)
      this.toastService.hideLoader()
   },(error:any)=>{
    this.toastService.hideLoader()
   })
   }
   else{
   this.toastService.hideLoader();
      this.toastService.create('Please login.')
      this.router.navigate(['/signin'])
   }
 
}
}
